import { forwardRef, type InputHTMLAttributes } from 'react'

import { cn } from '@/lib/cn'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean
}

const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, invalid, ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(
        'w-full rounded-card border bg-bg-elevated px-3 py-2 text-sm text-text-primary placeholder:text-text-faint transition',
        invalid
          ? 'border-danger'
          : 'border-border-subtle hover:border-border-strong',
        className,
      )}
      {...props}
    />
  )
})

export default Input
